export const compareTool = ['$cookies', '$http', '$window', function($cookies, $http, $window){
    let compare = {}
    compare.state = "ready";
    compare.fav_floorplans = [];
    compare.fav_properties = [];
    compare.favorites = $cookies.getObject('floorplan_favorites') || {floorplans:[], properties:[]};
    if (compare.favorites && !compare.favorites.floorplans && !compare.favorites.properties) {
        $cookies.remove('floorplan_favorites');
        compare.favorites = {floorplans:[], properties:[]};
    }

    if (compare.favorites) {
        compare.favoriteFloorplansCount = compare.favorites.floorplans.length
        compare.favoritePropertiesCount = compare.favorites.properties.length
    } else {
        compare.favoriteFloorplansCount = 0
        compare.favoritePropertiesCount = 0
    }

    compare.toggleFavorite = function(post_id, floorplan_id) {
        let favorites = $cookies.getObject('floorplan_favorites') || {floorplans:[], properties:[]};
        const fav_type = floorplan_id ? 'floorplans' : 'properties';
        let target_fp = [post_id, floorplan_id]
        const target_in_array = favorites[fav_type].some(fp => {
            if (floorplan_id) {
                return fp[0] === target_fp[0] && fp[1] === target_fp[1];
            } else {
                return fp[0] === target_fp[0];
            }
        })

        if (target_in_array) {
            // if in favourites filter it out
            let favholder = favorites[fav_type].filter(fp => {
                if (floorplan_id && fp[0] == target_fp[0] && fp[1] == target_fp[1]) {
                    return false;
                } else if (!floorplan_id && fp[0] == target_fp[0]) {
                    return false;
                }
                return true;
            })
            favorites[fav_type] = favholder;
        } else {
            favorites[fav_type].push(target_fp)
        }
        const now = new $window.Date();
        const exp = new $window.Date(now.getFullYear(), now.getMonth()+6, now.getDate());
        $cookies.putObject('floorplan_favorites', favorites, {expires: exp, path: '/'});
        compare.favorites = favorites
        compare.favoriteFloorplansCount = compare.favorites.floorplans.length
        compare.favoritePropertiesCount = compare.favorites.properties.length
        // console.log('favorites ' , favorites);
        floorplan_id ? compare.getFavoritedFloorplans() : compare.getFavoritedProperties();
    }
    compare.isFavorite = function(post_id, floorplan_id) {
        const fav_type = floorplan_id ? 'floorplans' : 'properties';
        const target_fp = [post_id, floorplan_id]
        const favorites = $cookies.getObject('floorplan_favorites') || {floorplans:[], properties:[]};
        const target_in_array = favorites[fav_type].some(fp => {
            if (floorplan_id) {
                return fp[0] === target_fp[0] && fp[1] === target_fp[1];
            } else {
                return fp[0] === target_fp[0];
            }
        })

        return favorites && target_in_array
    }

    compare.getFavoritedFloorplans = function() {
        compare.ids = compare.favorites.floorplans;
        compare.state = "loading";
        $http({
            method: 'POST',
            url: '/wp-json/richman/v1/floorplans',
            data: {
                ids: compare.ids
            }
        }).then(function successCallback(response) {
            compare.state = "ready";
            // console.log('response ' , response);
            compare.fav_floorplans = response.data;
            // console.log('compare.fav_floorplans ' , compare.fav_floorplans);
        }, function errorCallback(response) {
            compare.state = "error";
            // console.log('error response ' , response);
        });
    }
    compare.getFavoritedProperties = function() {
        compare.prop_ids = compare.favorites.properties;
        compare.prop_ids = compare.prop_ids.map(function(id) {
            return id[0]
        })
        compare.state = "loading";
        $http({
            method: 'GET',
            url: '/wp-json/wp/v2/properties',
            params: {
                include: compare.prop_ids.join(','),
                // include: compare.prop_ids,
                _embed: true
            }
        }).then(function successCallback(response) {
            compare.state = "ready";
            // console.log('response ' , response);
            compare.fav_properties = response.data;
            // console.log('compare.fav_floorplans ' , compare.fav_floorplans);
        }, function errorCallback(response) {
            compare.state = "error";
            // console.log('error response ' , response);
        });
    }
    return compare;

}]